export default __webpack_public_path__ + "locales/pt-BR/SendInviteDialog.json?hash=453ea7e95007239c83774932665864a1";